export default __webpack_public_path__ + "static/media/Contacts-widget-icon.f6423f38.svg";